// extracted by mini-css-extract-plugin
export default {"button":"LootboxOwnedEmptySection_button__4YZkK","content":"LootboxOwnedEmptySection_content__l5FH7","icon":"LootboxOwnedEmptySection_icon__M8zAJ"};